const FEATURE_MAPPING = {
  0: "phone_view",
  1: "listing_view",
  // 2-9 reserved
};

const getFeatureFlags = (flagString = "") => {
  const flags = flagString.padStart(10, "0");

  const isEnabled = (feature) => {
    const index = Object.entries(FEATURE_MAPPING).find(([, name]) => name === feature)?.[0];

    return index ? flags.charAt(Number(index)) === "1" : false;
  };

  const getAll = () => {
    return Object.entries(FEATURE_MAPPING).reduce((acc, [index, name]) => {
      acc[name] = flags.charAt(Number(index)) === "1";
      return acc;
    }, {});
  };

  return { isEnabled, getAll };
};

export default getFeatureFlags;
